module.exports = __webpack_public_path__ + "static/media/Project-Banking.984f1de3.svg";